import {defaultDataIdFromObject} from '@apollo/client/cache';

export default object => {
  // eslint-disable-next-line no-underscore-dangle
  switch (object.__typename) {
    // Skip using the typical typename + id key for the tip type.
    // Reason being that a request like:
    // { tip: {amount, id}, customerTip: {amount, id}}
    // results in the tip and customerTip using the same cache key since the id is just the order id
    // and thus customerTip would overwrite the tip object in the cache which leads to incorrect data
    // By returning null we tell the cache to use the full field path as the cache key which will be unique
    // ala "$CatererCart:<orderId>.tip" and "$CatererCart:<orderId>.customerTip"
    case 'Tip':
      return undefined;
    default:
      return defaultDataIdFromObject(object);
  }
};
